// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customDropTable--3R5eC2Q5 .ant-table-tbody tr.dropOverDownward--39aTjh24 td {\n        border-bottom: 2px dashed var(--antd-table-drop-hover-border-color);\n      }\n    .customDropTable--3R5eC2Q5 .ant-table-tbody tr.dropOverUpward--2rSU7-7z td {\n        border-top: 2px dashed var(--antd-table-drop-hover-border-color);\n      }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customDropTable": "customDropTable--3R5eC2Q5",
	"dropOverDownward": "dropOverDownward--39aTjh24",
	"dropOverUpward": "dropOverUpward--2rSU7-7z"
};
export default ___CSS_LOADER_EXPORT___;
